import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><path d="M4.001 0c-1.01.005-1 1-1 1v12l.002.016v.136c0 1.024.857 1.848 1.92 1.848h5.158c1.063 0 1.92-.824 1.92-1.848V5c0-1.023-.937-2-2-2h-5V1s-.009-.994-1-1zm1.754 5H9.25a.75.75 0 01.752.752v1.496A.75.75 0 019.251 8H5.755a.75.75 0 01-.752-.752V5.752A.75.75 0 015.755 5zm-.252 5h1.143a.499.499 0 110 1H5.503a.499.499 0 110-1zm2.857 0h1.143a.499.499 0 110 1H8.36a.499.499 0 110-1zm-2.857 2h1.143a.499.499 0 110 1H5.503a.499.499 0 110-1zm2.857 0h1.143a.499.499 0 110 1H8.36a.499.499 0 110-1z" style={{
      marker: "none"
    }} color="#000" overflow="visible" fill="#2e3436" /></svg>;
}

export default SvgComponent;